interface BodyProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Body: React.FC<BodyProps> = ({ children, className = '', style }) => {
  return (
    <div
      className={`tabsubcont ${className}`}
      style={{
        ...style,
        color: 'var(--bcs-semantic-base-txt-primary)',
        backgroundColor: 'var(--bcs-semantic-base-bg-default)',
        overscrollBehavior: 'none',
      }}
    >
      {children}
    </div>
  );
};

export default Body;
